import React, { Component } from "react";
import {
  Row,
  Col,
  Nav,
  NavItem,
  TabContent,
  TabPane,
  Card,
  CardBody,
} from "reactstrap";
import axios from "axios";
import { END_POINT, END_POINT_SOCKET } from "../../../constants/defaultValues";
import {
  SetItemsSelected,
  NotificatioErrController,
  NotificatioSucController,
} from "../../../helpers/Utils";import createSocket from "../../../helpers/createSocket";
import {
  PageHeading,
  ContentDisplay,
  WarehouseExportApplicationMenu,
  ListItemLeftForm,
  ListItemFormMobile,
  FooterWarehouseExport,
  AddWarehouseExport,
  UpdateWarehouseExport,
} from "../../../containers/pages/warehouse-export";
import { Pagination } from "../../../containers/pages/general";
import LogsHelper from "../../../helpers/Logs";
import IntlMessages from "../../../helpers/IntlMessages";
import classnames from "classnames";
import { isC, isR, isU, isD } from "../../../helpers/Roles";
import { NavLink } from "react-router-dom";
import { Separator } from "../../../components/common/CustomBootstrap";
import FooterPage from "../../../containers/pages/FooterPage";
import ContentMultiForm from "../../../containers/pages/warehouse-export/ContentMultiForm";
import { connect } from "react-redux";
import { setSearchContext } from "../../../redux/actions";

const DEFAULT_FORM = {
  id: "",
  stock: "",
  // code: '',
  // unit: '',
  quantity: "",
  status: "",
  price: "",
  description: "",
  // time: '',
  user: {},
  dynamic_form: [],
};

const ROLE_ALIAS = "warehouseExport";

class ContentComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: {
        pageSizes: [12, 24],
        selectedPageSize: 12,
        currentPage: 1,
        totalPage: 1,
        totalItem: 0,
        search: "",
      },
      selectedItems: [],
      data: [],
      data_all: [],
      data_stocks: [],

      data_warehouse_import: null,
      filter: null,

      data_dynamic_form: [],
      is_loading_data: true,
      show: {
        add: false,
        update: false,
        view: false,
        viewonly: true,
      },
      accordion: [],
      activeTab: "1",
      displayMode: "thumblist",
      form: DEFAULT_FORM,
    };

    this.socket = createSocket();
  }

  componentDidMount() {
    this.socket.emit("join room", {
      room_id: localStorage.getItem("user_id"),
    });

    // Set search context cho Navbar
    this.props.setSearchContext("warehouseExport");

    this.dataListRender();
    this.dataAllRender();
    this.dataListRenderStocksUnit();

    if (new URLSearchParams(window.location.search).get("action") === "create") {
      this.setState((prev) => ({
        ...prev,
        show: {
          ...prev.show,
          add: true,
          update: false,
          view: false,
          viewonly: false,
        },
      }));
    }
  }

  componentDidUpdate(prevProps) {
    // Listen thay đổi searchKeyword từ Redux (Navbar search)
    if (prevProps.searchKeyword !== this.props.searchKeyword) {
      this.setState(
        (prev) => ({
          ...prev,
          page: {
            ...prev.page,
            search: this.props.searchKeyword,
          },
        }),
        () => this.dataListRender()
      );
    }
  }

  /** Axios func helper */
  dataListRender = () => {
    const { selectedPageSize, currentPage, search } = this.state.page;

    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(
        `${
          END_POINT + "/warehouse-export/json"
        }?pageSize=${selectedPageSize}&currentPage=${currentPage}&search=${search}`,
        { headers: { Authorization: `Bearer ${tokenStr}` } }
      )
      .then((res) => res.data)
      .then((data) => {
        let anyAccordion = [];
        let numeroPerguntas = data.data.length;
        for (var i = 0; i < numeroPerguntas; i++) {
          // if (!i) {
          //     anyAccordion.push(true);
          // }
          anyAccordion.push(false);
        }
        this.setState(
          (prev) => ({
            ...prev,
            data: data.data,
            data_dynamic_form: data.dataDynamicForm,
            is_loading_data: false,
            page: {
              ...prev.page,
              totalPage: data.totalPage,
              totalItem: data.totalItem,
            },
            accordion: anyAccordion,
          }),
          () => {
            if (this.state.form.id) {
              const {
                id,
                stock,
                // code,
                // unit,
                quantity,
                status,
                price,
                description,
                // time,
                dynamic_form,
              } = this.state.form;
              this.setState((prev) => ({
                ...prev,
                form: {
                  ...prev.form,
                  id,
                  stock,
                  // code,
                  // unit,
                  quantity,
                  status,
                  price,
                  description,
                  // time,
                  dynamic_form,
                },
              }));
            } else {
              this.setState((prev) => ({
                ...prev,
                selectedItems: [],
                show: {
                  ...prev.show,
                  update: false,
                },
                form: DEFAULT_FORM,
              }));
            }
          }
        );
      })
      .catch((err) => {
        NotificatioErrController(err.response?.data.responseText);
        return false;
      });
  };

  dataAllRender = () => {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/warehouse-export"}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        this.setState((prev) => ({
          ...prev,
          data_all: data.data,
        }));
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  dataListRenderStocksUnit = () => {
    let tokenStr = localStorage.getItem("access_token");
    return axios
      .get(`${END_POINT + "/stock/all-unit"}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => {
        this.setState((prev) => ({
          ...prev,
          data_stocks: res.data.data,
        }));
      })
      .catch((err) => []);
  };

  onHandlerDelete = () => {
    if (!isD(ROLE_ALIAS)) return false;

    let tokenStr = localStorage.getItem("access_token");
    axios
      .delete(`${END_POINT + "/warehouse-export"}`, {
        data: {
          arrayId: this.state.selectedItems,
        },
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        NotificatioSucController("Thành công");

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["warehouseExport-delete"],
        });

        this.dataListRender();
        this.dataAllRender();
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  onHandlerUpdate = (e) => {
    if (!isU(ROLE_ALIAS)) return false;
    e.preventDefault();

    const {
      id,
      stock,
      // code,
      // unit,
      quantity,
      price,
      description,
      // time,
      dynamic_form,
    } = this.state.form;

    if (!id) {
      NotificatioErrController("Dữ liệu không hợp lệ");
      return;
    }

    let tokenStr = localStorage.getItem("access_token");
    axios
      .put(
        `${END_POINT + "/warehouse-export"}`,
        {
          id,
          stock,
          // code,
          // unit,
          quantity,
          price,
          description,
          // time,
          dynamic_form,
        },
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      )
      .then((res) => res.data)
      .then((data) => {
        NotificatioSucController("Thành công");

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["warehouseExport-update"],
        });

        this.dataListRender();
        this.dataAllRender();
        this.toggle("update");
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  onHandlerAdd = (e) => {
    if (!isC(ROLE_ALIAS)) return false;
    e.preventDefault();

    const {
      stock,
      // code,
      // unit,
      quantity,
      price,
      description,
      // time,
      dynamic_form,
    } = this.state.form;

    if (!stock) {
      NotificatioErrController("Tên mặt hàng cần được thêm vào");
      return;
    }
    // if (!unit) {
    //     NotificatioErrController('Đơn vị tính cần được thêm vào');
    //     return;
    // }
    if (!quantity) {
      NotificatioErrController("Số lượng xuất cần được thêm vào");
      return;
    }
    if (!price) {
      NotificatioErrController("Giá xuất cần được thêm vào");
      return;
    }
    // if (!time) {
    //     NotificatioErrController('Thống kê cần được thêm vào');
    //     return;
    // }

    let tokenStr = localStorage.getItem("access_token");
    axios
      .post(
        `${END_POINT + "/warehouse-export"}`,
        {
          stock,
          // code,
          // unit,
          quantity,
          price,
          description,
          // time,
          dynamic_form,
        },
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      )
      .then((res) => res.data)
      .then((data) => {
        NotificatioSucController("Thành công");

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["warehouseExport-create"],
        });

        this.dataListRender();
        this.dataAllRender();
        this.dataListRenderStocksUnit();
        // this.toggle('add');
        this.setState((prev) => ({
          ...prev,
          form: {
            ...prev.form,
            form: DEFAULT_FORM,
          },
        }));
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };
  /** Axios func helper */

  /** State func helper */
  toggle = (name) => {
    if (name === "add" && !isC(ROLE_ALIAS)) return false;
    if (name === "update" && !isU(ROLE_ALIAS)) return false;

    this.setState((prev) => ({
      ...prev,
      show: {
        ...prev.show,
        update: name === "add" ? false : prev.show.update,
        [name]: !prev.show[name],
      },
      selectedItems: name === "add" ? [] : prev.selectedItems,
      form: name === "add" ? DEFAULT_FORM : prev.form,
    }));
  };

  hideDisplayContent = () => {
    this.setState((prev) => ({
      ...prev,
      show: {
        ...prev.show,
        view: false,
      },
    }));
  };

  onChangeForm = (e, _name) => {
    if (e.target) {
      let {
        target: { name, value },
      } = e;
      this.setState((prev) => ({
        ...prev,
        form: {
          ...prev.form,
          [name]: value,
        },
      }));
    } else {
      this.setState((prev) => ({
        ...prev,
        form: {
          ...prev.form,
          [_name]: e.value,
        },
      }));
    }
  };
  onChangeDynamicForm = (e, _name) => {
    if (e.target) {
      let {
        target: { name, value },
      } = e;

      this.setState((prev) => ({
        ...prev,
        form: {
          ...prev.form,
          dynamic_form: {
            ...prev.form.dynamic_form,
            [name]: value,
          },
        },
      }));
    } else {
      let value = e.value ? e.value : e;

      this.setState((prev) => ({
        ...prev,
        form: {
          ...prev.form,
          dynamic_form: {
            ...prev.form.dynamic_form,
            [_name]: value,
          },
        },
      }));
    }
  };

  onSubmitForm = (type) => {
    if (type === "update") {
      this.onHandlerUpdate();
    } else if (type === "add") {
      this.onHandlerAdd();
    }
  };

  onChangePage = (page) => {
    this.setState(
      (prev) => ({
        ...prev,
        page: {
          ...prev.page,
          currentPage: page,
        },
      }),
      () => this.dataListRender()
    );
  };

  onSearchKey = (e) => {
    if (!e) return false;

    if (e.target) {
      let {
        target: { value },
      } = e;
      let v = value;
      if (value === undefined) {
        v = e.target.firstElementChild.value; // parent to child

        //     value = v.toLowerCase();
        //     this.setState(
        //         (prev) => ({
        //             ...prev,
        //             page: {
        //                 ...prev.page,
        //                 search: value,
        //             },
        //         }),
        //         () => this.dataListRender()
        //     );
        // } else {
        //     value = value.toLowerCase();
        //     this.setState(
        //         (prev) => ({
        //             ...prev,
        //             page: {
        //                 ...prev.page,
        //                 search: value,
        //             },
        //         }),
        //         () => this.dataListRender()
        //     );
      }
    }

    if (e.key === "Enter") {
      let value = e.target.value.toLowerCase();
      this.setState(
        (prev) => ({
          ...prev,
          page: {
            ...prev.page,
            search: value,
          },
        }),
        () => this.dataListRender()
      );
    }
  };

  onChangePageSize = (size) => {
    this.setState(
      (prev) => ({
        ...prev,
        page: {
          ...prev.page,
          selectedPageSize: size,
          currentPage: 1,
        },
      }),
      () => this.dataListRender()
    );
  };

  onClickedItem = (item, callback, args) => {
    // Open update modal when clicking on card
    const {
      id,
      stock,
      // code,
      // unit,
      quantity,
      price,
      description,
      user,
      // time,
      at,
      dynamic_form,
    } = item;

    this.setState(
      (prev) => ({
        ...prev,
        show: {
          ...prev.show,
          update: true,
          view: true,
          viewonly: false,
        },
        form: {
          ...prev.form,
          id,
          stock,
          // code,
          // unit,
          quantity,
          price,
          description,
          user: user ? user.fullname || user.username : "",
          // time,
          at,
          dynamic_form,
        },
        selectedItems: [item.id],
      }),
      () => {
        if (callback) callback(args[0], args[1], args[2]);
      }
    );
  };

  onClickedUpdate = (item) => {
    const {
      id,
      stock,
      // code,
      // unit,
      quantity,
      price,
      description,
      user,
      // time,
      at,
      dynamic_form,
    } = item;

    this.setState((prev) => ({
      ...prev,
      show: {
        ...prev.show,
        viewonly: false,
        update: true,
      },
      form: {
        ...prev.form,
        id,
        stock,
        // code,
        // unit,
        quantity,
        price,
        description,
        // time,
        user: user ? user.fullname || user.username : "",
        at,
        dynamic_form,
      },
      selectedItems: [item.id],
    }));
  };

  onClickedDelete = (item) => {
    let selectedSet = SetItemsSelected(
      item.id,
      this.state.selectedItems,
      "require"
    );
    if (window.confirm("Bạn chắc chắn muốn xoá phiếu xuất kho này?")) {
      this.setState(
        (prev) => ({
          ...prev,
          selectedItems: selectedSet,
        }),
        () => this.onHandlerDelete()
      );
    }
  };

  onClickedCheckbox = (id, event) => {
    // Toggle multi-select
    let selectedSet = SetItemsSelected(id, this.state.selectedItems);

    this.setState((prev) => ({
      ...prev,
      selectedItems: selectedSet,
    }));
  };

  toggleAccordion = (tab) => {
    const prevState = this.state.accordion;
    const state = prevState.map((x, index) => (tab === index ? !x : false));
    this.setState({
      accordion: state,
    });
  };

  toggleTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };

  filterData = (key, value) => {
    const { data_all, data } = this.state;
    // console.log('key: ', typeof key);
    console.log("key, value: ", key, value);

    if (key === "price" || key === "quantity") {
      if (value === 1000000 || value === 10) {
        const filteredData = data_all.filter(
          (item) => Number(item[key]) < value
        );
        this.setState((prev) => ({
          ...prev,
          data: filteredData,
          filter: { column: key, value },
        }));
      } else if (value === 10000000 || value === 50) {
        const filteredData = data_all.filter(
          (item) => Number(item[key]) > value
        );
        this.setState((prev) => ({
          ...prev,
          data: filteredData,
          filter: { column: key, value },
        }));
      } else if (value === 5000000 || value === 25) {
        if (key === "price") {
          const filteredData = data_all.filter(
            (item) =>
              Number(item[key]) <= 10000000 && Number(item[key]) >= 1000000
          );
          this.setState((prev) => ({
            ...prev,
            data: filteredData,
            filter: { column: key, value },
          }));
        }
        if (key === "quantity") {
          const filteredData = data_all.filter(
            (item) => Number(item.quantity) <= 50 && Number(item.quantity) >= 10
          );
          this.setState((prev) => ({
            ...prev,
            data: filteredData,
            filter: { column: key, value },
          }));
        }
      }
    } else {
      const filteredItems = data_all.filter((item) => item[key] === value);
      this.setState((prev) => ({
        ...prev,
        data: filteredItems,
        filter: { column: key, value },
      }));
    }
  };

  showAlertApprove = (item) => {
    if (window.confirm('Bạn chắc muốn "Xét duyệt" Phiếu xuất kho này?')) {
      // const { id } = this.state.form;
      const status = "approve";
      const tokenStr = localStorage.getItem("access_token");
      axios
        .put(
          `${END_POINT + "/warehouse-export/update_status"}`,
          {
            id: item.id,
            status,
            stock: item.stock,
            // unit: item.unit,
            quantity: item.quantity,
          },
          {
            headers: { Authorization: `Bearer ${tokenStr}` },
          }
        )
        .then((res) => res.data)
        .then((data) => {
          NotificatioSucController("Thành công");

          this.socket.emit("create logs", {
            user_id: localStorage.getItem("user_id"),
            message: LogsHelper["warehouseExport-update"],
          });

          this.dataListRender();
          this.dataAllRender();
          // this.toggle('update');
        })
        .catch((err) => {
          NotificatioErrController(err.response.data.responseText);
          return false;
        });
    }
  };

  showAlertReject = (id) => {
    if (window.confirm('Bạn chắc muốn "Từ chối" Phiếu xuất kho này?')) {
      const status = "reject";
      const tokenStr = localStorage.getItem("access_token");
      axios
        .put(
          `${END_POINT + "/warehouse-export/update_status"}`,
          {
            id,
            status,
          },
          {
            headers: { Authorization: `Bearer ${tokenStr}` },
          }
        )
        .then((res) => res.data)
        .then((data) => {
          NotificatioSucController("Thành công");

          this.socket.emit("create logs", {
            user_id: localStorage.getItem("user_id"),
            message: LogsHelper["warehouseExport-update"],
          });

          this.dataListRender();
          this.dataAllRender();
          // this.toggle('update');
        })
        .catch((err) => {
          NotificatioErrController(err.response.data.responseText);
          return false;
        });
    }
  };

  changeDisplayMode = (mode) => {
    this.setState((prev) => ({
      ...prev,
      displayMode: mode,
      show: {
        ...prev.show,
        view: false,
      },
    }));
    return false;
  };

  render() {
    const { match } = this.props;
    const {
      page,
      selectedItems,
      data,
      data_all,
      data_stocks,
      filter,
      is_loading_data,
      show,
      form,
      accordion,
      displayMode,
      // Dynamic Form
      data_dynamic_form,
    } = this.state;

    // console.log('data: ', data);
    // console.log('form: ', form);
    // console.log('data_all: ', data_all);
    // const dataRender = data_warehouse_import?.length ? data_warehouse_import : data;
    // console.log(dataRender);
    // console.log('selectedItems', selectedItems);

    if (!isR(ROLE_ALIAS))
      return (
        <Card className="text-muted mh-40vh h-100">
          <CardBody className="d-flex justify-content-center align-items-center">
            Bạn không có quyền sử dụng tính năng này!
          </CardBody>
        </Card>
      );

    return is_loading_data ? (
      <div className="loading" />
    ) : (
      <div
        // className={classnames(
        //     'disable-text-selection',
        //     displayMode === 'thumblist' ? 'app-row' : ''
        // )}
        className="app-row disable-text-selection"
      >
        <PageHeading
          heading="warehouse.export"
          setting={page}
          hideSearch={true}
          match={match}
          data={data}
          totalItem={page.totalItem}
          isDisabledAdd={!isC(ROLE_ALIAS)}
          isDisabledDel={!isD(ROLE_ALIAS)}
          isDisabledUpdate={!isU(ROLE_ALIAS)}
          toggleFunc={() => {
            this.toggle("add");
            this.hideDisplayContent();
            this.toggleAccordion();
          }}
          changePageSizeFunc={this.onChangePageSize}
          onSearchKeyFunc={this.onSearchKey}
          onHandlerDelete={() => {
            if (window.confirm("Bạn có chắc chắn muốn xóa bản ghi này?")) {
              this.onHandlerDelete();
            }
          }}
          displayMode={displayMode}
          changeDisplayMode={this.changeDisplayMode}
          selectedItemsLength={selectedItems.length}
        />
        <AddWarehouseExport
          title={<IntlMessages id="warehouse.add-new-modal-title" />}
          isOpen={show.add}
          toggle={() => {
            this.toggle("add");
          }}
          data_dynamic_form={data_dynamic_form}
          values={form}
          data_stocks={data_stocks}
          setting={show}
          onChange={this.onChangeForm}
          onChangeDynamicForm={this.onChangeDynamicForm}
          onSubmit={this.onHandlerAdd}
        />
        <UpdateWarehouseExport
          title={<IntlMessages id="warehouse.export-title" />}
          onSubmit={this.onHandlerUpdate}
          isOpen={show.update}
          toggle={() => {
            this.toggle("update");
          }}
          data_dynamic_form={data_dynamic_form}
          values={form}
          setting={show}
          onChange={this.onChangeForm}
          onChangeDynamicForm={this.onChangeDynamicForm}
        />
        {data.length === 0 ? (
          <Card className="mt-4 mb-4 mh-53vh">
            <CardBody>Chưa có dữ liệu...</CardBody>
          </Card>
        ) : (
          <>
            <Nav
              tabs
              className="d-flex justify-content-between separator-tabs ml-0 mb-5"
            >
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.activeTab === "1",
                    "nav-link": true,
                  })}
                  onClick={() => this.toggleTab("1")}
                  location={{}}
                  to="#"
                >
                  <IntlMessages id="general.info" />
                </NavLink>
              </NavItem>

              {/* <NavItem>
                                <NavLink
                                    className={classnames({
                                        active: this.state.activeTab === '2',
                                        'nav-link': true,
                                    })}
                                    onClick={() => this.toggleTab('2')}
                                    location={{}}
                                    to='#'
                                >
                                    <span className='mr-2'>
                                        <i className='simple-icon-settings'></i>
                                    </span>
                                    <IntlMessages id='general.setting' />
                                </NavLink>
                            </NavItem> */}
            </Nav>
            <TabContent activeTab={this.state.activeTab} className="mh-53vh">
              <TabPane tabId="1">
                <Row className="content-page__row d-none d-md-flex">
                  <Col
                    xs="12"
                    // sm="12"
                    // md="12"
                    // lg={show.view && displayMode === "thumblist" ? 6 : 12}
                    // xl={show.view && displayMode === "thumblist" ? 6 : 12}
                  >
                    {data?.length ? (
                      displayMode === "thumblist" ? (
                        <>
                          {data?.map((item, idx) => (
                            <ListItemLeftForm
                              onClickedItem={this.onClickedItem}
                              onUpdate={this.onClickedUpdate}
                              onDelete={this.onClickedDelete}
                              onChangeCheckbox={this.onClickedCheckbox}
                              showAlertApprove={this.showAlertApprove}
                              showAlertReject={this.showAlertReject}
                              isDisabledUpdate={!isU(ROLE_ALIAS)}
                              isDisabledDelete={!isD(ROLE_ALIAS)}
                              selectedItems={selectedItems}
                              setting={show}
                              key={idx}
                              idx={idx}
                              item={item}
                            />
                          ))}
                          {/* {data?.length <
                                                    12 ? null : ( */}
                          <Pagination
                            currentPage={page.currentPage}
                            totalPage={page.totalPage}
                            onChangePage={(i) => this.onChangePage(i)}
                          />
                          {/* )} */}
                        </>
                      ) : (
                        <ContentMultiForm data={data_all} />
                      )
                    ) : (
                      <Card className="d-flex justify-content-center align-items-center">
                        <CardBody>Chưa có dữ liệu...</CardBody>
                      </Card>
                    )}
                  </Col>
                  {/* ContentDisplay commented out - không cần hiển thị nữa
                  {show.view ? (
                    <Col xs="12" sm="12" md="12" lg="6" xl="6">
                      <ContentDisplay
                        // data_dynamic_form={data_dynamic_form}
                        values={form}
                        data_stocks={data_stocks}
                      />
                    </Col>
                  ) : null} */}
                </Row>
                <Row className="content-page__row d-block d-md-none mb-4">
                  <Col>
                    {data?.length ? (
                      data?.map((item, idx) => {
                        // console.log(item);
                        return (
                          <div className="d-flex mb-3 card" key={item.id}>
                            <ListItemFormMobile
                              onClickedItem={this.onClickedItem}
                              onUpdate={this.onClickedUpdate}
                              onDelete={this.onClickedDelete}
                              onChangeCheckbox={this.onClickedCheckbox}
                              isDisabledUpdate={!isU(ROLE_ALIAS)}
                              isDisabledDelete={!isD(ROLE_ALIAS)}
                              selectedItems={selectedItems}
                              key={idx}
                              idx={idx}
                              item={item}
                              data_stocks={data_stocks}
                              form={form}
                              accordion={accordion}
                              toggleAccordion={this.toggleAccordion}
                            />
                          </div>
                        );
                      })
                    ) : (
                      <Card className="d-flex justify-content-center align-items-center">
                        <CardBody>Chưa có dữ liệu...</CardBody>
                      </Card>
                    )}
                    {/* {data?.length < 12 ? null : ( */}
                    <Pagination
                      currentPage={page.currentPage}
                      totalPage={page.totalPage}
                      onChangePage={(i) => this.onChangePage(i)}
                    />
                    {/* )} */}
                  </Col>
                </Row>
              </TabPane>
              {/* <TabPane tabId='2'>Setting</TabPane> */}
            </TabContent>
          </>
        )}
        <WarehouseExportApplicationMenu
          data={data_all}
          // data_warehouse_import={data_warehouse_import}
          filter={filter}
          filterData={(key, value) => this.filterData(key, value)}
        />
        <Separator />
        <FooterPage>
          <FooterWarehouseExport />
        </FooterPage>
      </div>
    );
  }
}

const mapStateToProps = ({ searchInput }) => {
  const { keyword: searchKeyword } = searchInput;
  return { searchKeyword };
};

export default connect(mapStateToProps, {
  setSearchContext,
})(ContentComponent);
